/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Page_X_Of_YInputs */



/**
* | output |
* | --- |
* | "Page {current} of {total}" |
*
* @param {Page_X_Of_YInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const page_x_of_y = /** @type {((inputs: Page_X_Of_YInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_X_Of_YInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Page ${i?.current} de ${i?.total}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Seite ${i?.current} von ${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Pagina ${i?.current} di ${i?.total}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Страница ${i?.current} из ${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`第 ${i?.current} 页，共 ${i?.total} 页`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ページ ${i?.current} / ${i?.total}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`पृष्ठ ${i?.current} का ${i?.total}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
	return /** @type {LocalizedString} */ (`Page ${i?.current} of ${i?.total}`)
});